import React from "react";
import PropTypes from "prop-types";
import styles from "components/grid/cell-formatters/focus-cell-formatters.scss";
import { documentPropType } from "custom-prop-types";
import { isValidValue } from "utils/validators";
import { normalizeNumber } from "utils/string-helpers";

export const MoneyCellFormatter = ({
  accountId,
  defaultCurrency,
  document,
  field,
  isFocused,
  onUpdateDocument,
  onUpdateInlineDocument,
  value
}) => {
  if (isFocused && document.type === "receipt") {
    return (
      <div>
        <input
          className={ styles.input }
          defaultValue={ value }
          onBlur={ (e) => (
            onUpdateInlineDocument({ accountId, document, field, value: normalizeNumber(e.target.value) })
          ) }
          onChange={ (e) => onUpdateDocument(field, normalizeNumber(e.target.value)) }
          type="text"
        />
      </div>
    );
  }
  return (
    <SimpleMoneyCellFormatter
      currency={ document.currency }
      defaultCurrency={ defaultCurrency }
      value={ value }
    />
  );
};

MoneyCellFormatter.defaultProps = {
  currency: "AUD",
  defaultCurrency: "AUD",
  value: undefined
};

MoneyCellFormatter.propTypes = {
  accountId: PropTypes.string.isRequired,
  defaultCurrency: PropTypes.string,
  document: documentPropType.isRequired,
  field: PropTypes.string.isRequired,
  isFocused: PropTypes.bool.isRequired,
  onUpdateDocument: PropTypes.func.isRequired,
  onUpdateInlineDocument: PropTypes.func.isRequired,
  value: React.PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ])
};

export const SimpleMoneyCellFormatter = ({ currency, defaultCurrency, value }) => {
  if (!isValidValue(value)) {
    return <div />;
  }
  const currencySymbol = getCurrencySymbol(currency, defaultCurrency, value);
  if (currency !== defaultCurrency) {
    return <div><i>{value < 0 ? "-" : ""}{currencySymbol}{formatNumber(value)}</i></div>;
  }
  return <div>{value < 0 ? "-" : ""}{currencySymbol}{formatNumber(value)}</div>;
};

SimpleMoneyCellFormatter.defaultProps = {
  currency: "AUD",
  defaultCurrency: "AUD",
  value: undefined
};

SimpleMoneyCellFormatter.propTypes = {
  currency: PropTypes.string,
  defaultCurrency: PropTypes.string,
  value: React.PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ])
};

const getCurrencySymbol = (currency) => {
  switch (currency) {
    case "HKD":
    case "NZD":
    case "USD":
    case "CAD":
    case "AUD":
    case "SGD":
      return <span>$<span className={ styles.currency }>{currency}</span></span>;
    case "CHF":
      return <span>Fr<span className={ styles.currency }>{currency}</span></span>;
    case "MXN":
      return <span>Ps<span className={ styles.currency }>{currency}</span></span>;
    case "EUR":
      return <span>€<span className={ styles.currency }>{currency}</span></span>;
    case "SEK":
    case "DKK":
    case "NOK":
      return <span>Kr<span className={ styles.currency }>{currency}</span></span>;
    case "JPY":
    case "CNY":
      return <span>¥<span className={ styles.currency }>{currency}</span></span>;
    case "PLN":
      return <span>zł<span className={ styles.currency }>{currency}</span></span>;
    case "GBP":
      return <span>£<span className={ styles.currency }>{currency}</span></span>;
    case "PHP":
      return <span>₱<span className={ styles.currency }>{currency}</span></span>;
    case "ZAR":
      return <span>R<span className={ styles.currency }>{currency}</span></span>;
    case "CZK":
      return <span>Kč<span className={ styles.currency }>{currency}</span></span>;
    case "INR":
      return <span>₹<span className={ styles.currency }>{currency}</span></span>;
    case "IDR":
      return <span>Rp<span className={ styles.currency }>{currency}</span></span>;
    case "RON":
      return <span>lei<span className={ styles.currency }>{currency}</span></span>;
    case "THB":
      return <span>฿<span className={ styles.currency }>{currency}</span></span>;
    case "HUF":
      return <span>ft<span className={ styles.currency }>{currency}</span></span>;
    case "MYR":
      return <span>RM<span className={ styles.currency }>{currency}</span></span>;
    default:
      return <span>$<span className={ styles.currency }>{currency}</span></span>;
  }
};

const formatNumber = number => Math.abs(number).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");



// WEBPACK FOOTER //
// ./src/js/components/grid/cell-formatters/money-cell-formatter.jsx